import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 460,
  maxWidth: "92vw",
  // The details slot can carry a long summary; the dialog scrolls inside
  // itself rather than pushing its buttons off a short viewport.
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",

  border: "2px solid #E2E8F0",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

/**
 * A small reusable confirmation modal styled to match the app's warning
 * modals (MUI Modal + Box). Rendered with open={false} when inactive.
 */
// tone: "danger" (default, rose) for destructive confirmations; "primary"
// (violet) for affirmative ones such as activating a task.
// children (optional): a details block between the message and the buttons,
// e.g. a summary card of the thing being confirmed, so the title can stay
// short instead of carrying a long quoted name.
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  onConfirm,
  onCancel,
  tone = "danger",
  children,
}) => {
  const primary = tone === "primary";
  return (
    <Modal open={!!open} onClose={onCancel}>
      <Box sx={boxStyle}>
        <button
          type="button"
          aria-label="Close"
          className="absolute right-3 top-3 w-8 h-8 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 flex items-center justify-center"
          onClick={onCancel}
        >
          <CloseIcon style={{ fontSize: "20px" }} />
        </button>
        <div className="flex items-start gap-3 pr-8">
          <span
            className={`w-10 h-10 rounded-full flex-none flex items-center justify-center ${
              primary ? "bg-violet-50 text-violet-700" : "bg-rose-50 text-rose-700"
            }`}
          >
            {primary ? (
              <CheckCircleOutlineIcon style={{ fontSize: "22px" }} />
            ) : (
              <WarningIcon style={{ fontSize: "22px" }} />
            )}
          </span>
          <div className="min-w-0 pt-1">
            <h3 className="text-lg font-semibold text-slate-900 leading-snug break-words">{title}</h3>
            {message ? (
              <p className="text-sm text-slate-500 mt-1.5 whitespace-pre-wrap break-words">{message}</p>
            ) : null}
          </div>
        </div>
        {children ? <div className="mt-4">{children}</div> : null}
        <div className="flex justify-end gap-2 mt-6">

          <button
            className="px-4 py-2 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 text-sm font-medium"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 rounded-lg text-white text-sm font-medium ${
              primary
                ? "bg-violet-700 hover:bg-violet-800"
                : "bg-rose-600 hover:bg-rose-700"
            }`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDialog;
